import styled from "styled-components";

export const ThresholdList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
`;
